/**
 * Clipboard utility with fallback for Office Add-in WebView on Windows.
 *
 * The `navigator.clipboard` API is often unavailable or blocked inside the
 * Office taskpane WebView (especially on Windows).  This helper tries the
 * modern API first and falls back to the legacy `document.execCommand('copy')`
 * approach using a temporary off-screen textarea.
 */
export async function copyTextToClipboard(text) {
    // Try the modern Clipboard API first
    if (navigator.clipboard?.writeText) {
        try {
            await navigator.clipboard.writeText(text);
            return;
        }
        catch {
            // Permission denied or not available – fall through to legacy path
        }
    }
    // Legacy fallback using execCommand
    const textarea = document.createElement('textarea');
    textarea.value = text;
    // Place off-screen so it doesn't cause layout shift
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    textarea.style.top = '-9999px';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    try {
        const success = document.execCommand('copy');
        if (!success) {
            throw new Error('execCommand copy returned false');
        }
    }
    finally {
        document.body.removeChild(textarea);
    }
}
